export default __webpack_public_path__ + "static/media/header-visuel-3.4cf00a94.webp";